import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgErrorIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 180 180",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		id: "Property 1=Error",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Error",
			children: [/* @__PURE__ */ _jsxs("g", {
				id: "Illustration",
				children: [
					/* @__PURE__ */ _jsx("path", {
						id: "Fill-1",
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M59.7263 27.9149C69.6213 27.0026 79.1342 29.6387 86.7125 36.214C92.9475 41.6238 97.9893 48.6842 105.483 52.4726C113.466 56.5087 119.312 58.0208 127.838 56.0181C158.928 48.7146 175.543 98.8327 154.706 128.683C133.869 158.533 72.6734 177.65 34.756 126.641C-3.16079 75.6334 16.7307 50.8698 35.4593 37.1347C42.275 32.1361 50.9638 28.7228 59.7263 27.9149Z",
						fill: "#D32F2F",
						fillOpacity: .04
					}),
					/* @__PURE__ */ _jsx("mask", {
						id: "mask0_11110_81206",
						style: { maskType: "alpha" },
						maskUnits: "userSpaceOnUse",
						x: 46,
						y: 37,
						width: 87,
						height: 87,
						children: /* @__PURE__ */ _jsx("circle", {
							id: "Oval",
							cx: 89.2849,
							cy: 80.823,
							r: 42.8386,
							fill: "white"
						})
					}),
					/* @__PURE__ */ _jsx("g", { mask: "url(#mask0_11110_81206)" }),
					/* @__PURE__ */ _jsxs("g", {
						id: "Fill 1 100",
						clipPath: "url(#clip0_11110_81206)",
						children: [/* @__PURE__ */ _jsx("circle", {
							id: "Ellipse 2",
							cx: 146.696,
							cy: 59.3662,
							r: 2,
							fill: "#F44336"
						}), /* @__PURE__ */ _jsx("circle", {
							id: "Ellipse 3",
							cx: 34.6963,
							cy: 40.3662,
							r: 3.5,
							stroke: "#EF5350",
							strokeWidth: 3
						})]
					}),
					/* @__PURE__ */ _jsx("ellipse", {
						id: "Ellipse 4",
						cx: 117.205,
						cy: 28.5841,
						rx: 2.00871,
						ry: 2.01536,
						fill: "#F44336"
					}),
					/* @__PURE__ */ _jsx("ellipse", {
						id: "Ellipse 3_2",
						cx: 166.418,
						cy: 95.0911,
						rx: 4.01742,
						ry: 4.03073,
						fill: "#F44336"
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Ellipse 2_2",
						d: "M21.2951 121.291C21.2951 123.25 19.7137 124.829 17.7734 124.829C15.833 124.829 14.2516 123.25 14.2516 121.291C14.2516 119.332 15.833 117.752 17.7734 117.752C19.7137 117.752 21.2951 119.332 21.2951 121.291Z",
						stroke: "#EF5350",
						strokeWidth: 3
					})
				]
			}), /* @__PURE__ */ _jsx("path", {
				id: "Union",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M42 98C42 71.5857 63.4428 50 90 50C116.555 50 138 71.4447 138 98C138 124.414 116.557 146 90 146C63.5857 146 42 124.557 42 98ZM50.6746 98C50.6746 119.696 68.3038 137.325 90 137.325C111.696 137.325 129.325 119.696 129.325 98C129.325 76.3037 111.696 58.6745 90 58.6745C68.3038 58.6745 50.6746 76.3037 50.6746 98ZM93.6232 109.237L94.4928 73.4078H85.2536L86.1594 109.237H93.6232ZM86.3043 117.017C85.4348 117.878 85 118.948 85 120.227C85 121.46 85.4348 122.518 86.3043 123.402C87.1981 124.262 88.43 124.693 90 124.693C91.5459 124.693 92.7657 124.262 93.6594 123.402C94.5531 122.518 95 121.46 95 120.227C95 118.948 94.5531 117.878 93.6594 117.017C92.7657 116.134 91.5459 115.692 90 115.692C88.43 115.692 87.1981 116.134 86.3043 117.017Z",
				fill: "#F44336"
			})]
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_11110_81206",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 125,
			height: 117,
			fill: "white",
			transform: "translate(29.6963 35.3662)"
		})
	}) })]
});
export default SvgErrorIcon;
